import {ChartData, ChartSpec} from '../../shared/charts/chart-spec/chart-spec.interfaces';
import {ElasticQuerySearch} from '../elasticquery.interfaces';

export enum ReportAnalysisStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
  FAILED = 'FAILED'
}

export interface ReportAnalyticsRequest {
  document: string;
  query: ElasticQuerySearch;
  reportName?: string;
}

export interface ChartSuggestion {
  spec: ChartSpec;
  data: ChartData;
  insight?: string;
}

export interface DatasetOverview {
  totalRows: number;
  analysedRows: number;
  truncated: boolean;
}

export interface ReportAnalysisResult {
  dataset: DatasetOverview;
  suggestions: ChartSuggestion[];
  aiGenerated: boolean;
}

export interface ReportAnalysis {
  jobId: string;
  status: ReportAnalysisStatus;
  errorCode?: string;
  result?: ReportAnalysisResult;
}

export interface ChartRefineResponse {
  answerable: boolean;
  suggestion?: ChartSuggestion;
  message?: string;
  missingFields?: string[];
  followUps?: string[];
}
